import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject, take, takeUntil } from 'rxjs';
import { ViewContainersService } from '../shared/services/view-containers.service';

@Injectable({
  providedIn: 'root'
})
export class RelationService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  private selectedRow:BehaviorSubject<any> = new BehaviorSubject<any>(null);
  
  private refreshList:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  constructor(private viewContainersService:ViewContainersService) { }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setRefreshList(state: boolean): void {
    this.refreshList.subscribe(data => {
      console.log({RefreshList:data,Component:"RelationService",Comment:"RefreshList before Setting ..."});
    })
    if(state == true){
      this.refreshList.next(true);
    }else{
      this.refreshList.next(false);
    }
    this.refreshList.subscribe(data => {
      console.log({RefreshList:data,Component:"RelationService",Comment:"RefreshList after Setting"});
    })
    
  }

  getRefreshList():Observable<Boolean> {
    this.refreshList.subscribe(data => {
      console.log({RefreshList:data,Component:"RelationService",Comment:"Getting Current RefreshList"});
    })
    return this.refreshList.asObservable()
  }

  setSelectedRow(data:any){
    console.log({notifiedSucces:data});
    //console.log("breadCrumbAlert in ViewContainersService",data);
    this.selectedRow.next(data);
  }

  getSelectedRow(){
    this.selectedRow.subscribe(data => {
      console.log(data);
    })
    return this.selectedRow.asObservable();
  }
}
